import '@/assets/styles/components/footer.styles.scss';
import FooterLogo from '../../assets/svg/main-footer-logo.svg';
import { CONTRACTS } from '@/constants';
import { useContractModal } from '@/hooks/useContractModal';
import MeetProviderTestModal from '@/components/meet-provider-test-modal';
import { If } from "vite-plugin-react-control-statements";
import { useQueryProvider } from "@/hooks";
import { QUERY_KEYS } from "@/constants/QueryKeys.ts";
import { useApi } from "@/api/useApi.tsx";

const Footer = () => {
	const { onContractClick, ContractModal } = useContractModal();
    const { MenuItemControllerApi } = useApi();

    const { data: apiResponse } = useQueryProvider([QUERY_KEYS.getAllMenuItems], () => MenuItemControllerApi.getAllMenuItems(), {
        select: ({ data }) => data,
        refetchOnWindowFocus: false
    });

    const showMeetProviderTestModal= apiResponse?.data?.some(item => item.liveServiceGroupName === "COACHING" || item.liveServiceGroupName === "GOT_IT") || false;

	return (
		<footer className="footer">
			<div className="container">
				<div className="footer__content">
					<div className="footer__logo">
						<img
							src={FooterLogo}
							alt="Doping Footer"
						/>
					</div>

					<div className="footer__links">
						<button
							className="footer__link"
							onClick={() => onContractClick(CONTRACTS.CLARIFICATION_TEXT)}>
							Aydınlatma Metni
						</button>

						<button
							className="footer__link"
							onClick={() => onContractClick(CONTRACTS.APPLICANT_MEMBERSHIP_AGREEMENT)}>
							Bire Bir Uzman Üyelik Koşulları
						</button>

						<button
							className="footer__link"
							onClick={() => onContractClick(CONTRACTS.COMMERCIAL_CONFIRM_TEXT)}>
							Ticari İleti Metni
						</button>
					</div>
				</div>
			</div>

			<ContractModal />
            <If condition={showMeetProviderTestModal}>
			    <MeetProviderTestModal />
            </If>
		</footer>
	);
};

export default Footer;
